import { Box } from "@mui/material";
import { useTranslation } from "../../localization/useTranslation";
import AiUsageBox from "../aiUsageBox/AiUsageBox";
import { AiSpendingBreakdown } from "../AiAdministration.types";
import WrappedGift from "../wrapped-gift.svg?react";

export interface WelcomeOfferBoxProps {
    welcomeCreditEur: number;
    breakdown: AiSpendingBreakdown | null;
    isLoading?: boolean;
}

function WelcomeOfferBox(props: WelcomeOfferBoxProps) {
    const { translateString } = useTranslation();

    const usage = {
        contractCreations: props.breakdown?.contractCreation ?? 0,
        obligationExtractions: props.breakdown?.obligationExtraction ?? 0,
        documentScans: props.breakdown?.qualityScanOfDocuments ?? 0,
        chats: props.breakdown?.chat ?? 0,
    };

    const header = (
        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
            <WrappedGift width={24} height={24} />
            {translateString("welcomeOffer")}
        </Box>
    );

    return (
        <AiUsageBox
            header={header}
            info={translateString("welcomeOfferSubtitle", { amount: props.welcomeCreditEur })}
            limit={props.welcomeCreditEur}
            usage={usage}
            isLoading={props.isLoading}
        />
    );
}

export default WelcomeOfferBox;
